<template>
	<div id="credenciasInternas">

		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="20">
				<a-input-search
					v-model="strSearch"
					:maxLength=100
					placeholder="Insira o nome a ser pesquisado"
					@search="onSearch"					
					:disabled="loading"
				>
					<a-button slot="enterButton" type="primary" :disabled="loading">Pesquisar</a-button>
				</a-input-search>
			</a-col>
			<a-col :span="4" style="text-align: right;">
				<a-button
					type="primary"						
					class="tr-search-btn"
					style="width: 130px;"
					@click.stop.prevent="onNewCredencial"
					:disabled="loading"
					v-if="habilitarFuncionalidade('PermitirIncluir')"
				>Nova Credencial</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columns"
				:rowKey="record => record.idCredencial"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<template slot="ativa" slot-scope="ativa, record">					
					<a-icon type="check-circle" class="sucess" v-if="record.ativa"/>
					<a-icon type="close-circle" class="danger" v-else/>					
				</template>
				<template slot="editar" slot-scope="editar, record">
					<div>
						<a-tooltip>
							<template slot="title">Editar credencial</template>
							<a-icon 
								type="form" 
								class="cursor"
								@click="handleEditarCredencial(record)"/>
						</a-tooltip>
					</div>
				</template>
			</a-table>
			
			<modal-component
				class="modal-component"
				title="Editar Credencial"
				ref="modaleditcred"
				width="50%"
				:maskClosable="false"
			>
				<a-row>
					<span class="tr-label">Tribunal:</span>
					<a-select 					
						placeholder="Selecione o tipo acesso do usuário"
						style="width: 100%;"
						@change="handleChangeCredencialFonte"
						:value="valueCredencialFonte"
						>
						<a-select-option v-for="credencialFontes in credencialFontes" :key="credencialFontes.idDivisaoTribunal">
							{{credencialFontes.nome}}
						</a-select-option>
					</a-select>
				</a-row>
				<a-row>
					<span class="tr-label">Usuário:</span>					
					<a-input
						:maxLength=100
						placeholder="Insira o nome do usuário" 
						v-model="credenciaisInternas.usuario"
						:allowClear="credenciaisInternas.usuario!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Senha:</span>					
					<a-input-password
						:maxLength=100
						placeholder="Insira a senha" 
						v-model="credenciaisInternas.senha" 
						:allowClear="credenciaisInternas.senha!=''"
					>
						<a-icon slot="prefix" type="lock"/>
					</a-input-password>
				</a-row>
				<a-row >
					<a-col :span="24">
						<span class="tr-label">Tipo Credencial:</span>						
						<a-select
							placeholder="Selecione o tipo de crendecial"
							style="width: 100%;"
							:value="valueTipoCredencial"
							@change="handleSelectTipoCredencialChange"
						>
							<a-select-option
								v-for="tpTipoCredencial in tpTipoCredencialData"
								:key="tpTipoCredencial.key"
								:value="tpTipoCredencial.key"
							>{{tpTipoCredencial.descricao}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Ordem:</span>					
					<a-input
						placeholder="Insira a ordem da credencial"
						v-model="credenciaisInternas.ordem"
						:allowClear="credenciaisInternas.ordem!=''"
					>
						<a-icon slot="prefix" type="ordered-list"/>
					</a-input>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Quantidade de Acesso:</span>					
					<a-input
						placeholder="Insira a Quantidade de acesso para a credenciaisInternas"
						v-model="credenciaisInternas.limite"
						:allowClear="credenciaisInternas.limite!=''"
					>
						<a-icon slot="prefix" type="plus-circle"/>
					</a-input>
				</a-row>
				<a-row v-if="(this.credenciaisInternas.ativa == false)">
					<span>Motivo para a desativação:</span>					
					<a-textarea
						placeholder="Informe o motivo, para a desativação da credenciaisInternas"
						no-resize
						v-model="credenciaisInternas.observacao"
						:allowClear="credenciaisInternas.observacao!=''"
					>
						<a-icon slot="prefix" type="plus-circle"/>
					</a-textarea>
				</a-row>
				<a-row style="margin-top: 15px;">				
				<a-col :span="24" style="text-align: left; background-color: #eaeaea;">
					<div style="margin: 15px 20px 10px 20px;">							
						<span style="font-weight: 400; font-size: 16px;" v-html="textoTermo"/>
					</div>
				</a-col>					
				</a-row>
				<a-row style="margin-top: 5px;">
					<a-checkbox @change="onChangeCheck" :checked="termoAceite">
						Li e aceito os termos
					</a-checkbox>
				</a-row>
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">
							<a-switch style="margin-left: 15px;" defaultChecked v-model="credenciaisInternas.ativa" @change="handlerSwitchChange">
								<a-icon type="check" slot="checkedChildren"/>
								<a-icon type="close" slot="unCheckedChildren"/>
							</a-switch>
							<span style="margin-left: 10px;" v-if="credenciaisInternas.ativa">Ativo</span>
							<span style="margin-left: 10px;" v-else>Inativo</span>
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="credencial-form-button" @click.prevent="handleCancelEditCredencialModal">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="credencial-form-button"
										type="primary"
										@click.prevent="handleOkEditCli"
										:disabled="!termoAceite"
										v-if="habilitarFuncionalidade('PermitirAlterar')"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</span>
			</modal-component>

			<modal-component
				class="modal-component"				
				title="Nova Credencial"
				ref="modalnewcred"
				width="50%"
				:maskClosable="false"
			>
				<a-row>
					<span class="tr-label">Tribunal:</span>
					<a-select 					
						placeholder="Selecione o tipo acesso do usuário"
						style="width: 100%;"
						@change="handleChangeCredencialFonte"
						:value="valueCredencialFonte"
						>
						<a-select-option v-for="credencialFontes in credencialFontes" :key="credencialFontes.idDivisaoTribunal">
							{{credencialFontes.nome}}
						</a-select-option>
					</a-select>
				</a-row>
				<a-row>
					<span class="tr-label">Usuário:</span>					
					<a-input
						:maxLength=100
						placeholder="Insira o nome do usuário" 
						v-model="credenciaisInternas.usuario"
						:allowClear="credenciaisInternas.usuario!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Senha:</span>					
					<a-input-password
						:maxLength=100
						placeholder="Insira a senha" 
						v-model="credenciaisInternas.senha" 
						:allowClear="credenciaisInternas.senha!=''"
					>
						<a-icon slot="prefix" type="lock"/>
					</a-input-password>
				</a-row>
				<a-row >
					<a-col :span="24">
						<span class="tr-label">Tipo Credencial:</span>						
						<a-select
							placeholder="Selecione o tipo de crendecial"
							style="width: 100%;"
							:value="valueTipoCredencial"
							@change="handleSelectTipoCredencialChange"
						>
							<a-select-option
								v-for="tpTipoCredencial in tpTipoCredencialData"
								:key="tpTipoCredencial.key"
								:value="tpTipoCredencial.key"
							>{{tpTipoCredencial.descricao}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Ordem:</span>					
					<a-input
						placeholder="Insira a ordem da credencial"
						v-model="credenciaisInternas.ordem"
						:allowClear="credenciaisInternas.ordem!=''"
					>
						<a-icon slot="prefix" type="ordered-list"/>
					</a-input>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Quantidade de Acesso:</span>					
					<a-input
						placeholder="Insira a Quantidade de acesso para a credencial"
						v-model="credenciaisInternas.limite"
						:allowClear="credenciaisInternas.limite!=''"
					>
						<a-icon slot="prefix" type="plus-circle"/>
					</a-input>
				</a-row>
				<a-row style="margin-top: 15px;">				
				<a-col :span="24" style="text-align: left; background-color: #eaeaea;">
					<div style="margin: 15px 20px 10px 20px;">							
						<span style="font-weight: 400; font-size: 16px;" v-html="textoTermo"/>
					</div>
				</a-col>					
				</a-row>
				<a-row style="margin-top: 5px;">
					<a-checkbox @change="onChangeCheck" :checked="termoAceite">
						Li e aceito os termos
					</a-checkbox>
				</a-row>
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">														
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="credencial-form-button" @click.prevent="handleCancelNewCred">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="credencial-form-button"
										type="primary"
										@click.prevent="handleOkNewCred"
										:disabled="!termoAceite"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>					
				</span>
			</modal-component>
		</a-row>
	</div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const tpTipoCredencialData = [{ key:1, descricao:"Dado" }, { key:2, descricao:"Autos" }, { key:3, descricao:"Autos/Dado" }];

const columns = [
	{
		title: "Tribunal",
		dataIndex: "nome",
		width: "9%",
		sorter: (a, b) => a.nome.localeCompare(b.nome),		
		scopedSlots: { customRender: "nome" }
	},
	{
		title: "Usuario",
		dataIndex: "usuario",
		sorter: (a, b) => a.usuario.localeCompare(b.usuario),
		width: "5%",
		scopedSlots: { customRender: "Usuario" }
	},
	{
		title: "Ordem",
		dataIndex: "ordem",
		sorter: (a, b) => a.ordem.localeCompare(b.ordem),
		width: "5%",
		scopedSlots: { customRender: "ordem" }
	},
	{
		title: "Contador",
		dataIndex: "contador",
		sorter: (a, b) => a.contador.localeCompare(b.contador),
		width: "6%",
		scopedSlots: { customRender: "contador" }
	},
	{
		title: "Limite",
		dataIndex: "limite",
		sorter: (a, b) => a.limite.localeCompare(b.limite),
		width: "5%",
		scopedSlots: { customRender: "limite" }
	},
	{
		title: "Situação",
		dataIndex: "ativa",
		sorter: (a, b) => a.ativa - b.ativa,		
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "ativa" }
	},	
	{
		key: "IdCredencial",
		title: "Editar",
		dataIndex: "editar",
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "editar" }
	}
];

export default {	
	name: "credenciasInternas",
	data() {
		return {
			idTela: 7,
			data: [],
			pagination: {},
			loading: false,
			columns,
			fileListUpload: [],
			strSearch: null,
			searchText: "",
			searchInput: null,
			textoTermo: '',
			credenciaisInternas: {
				idCredencial: 0,
				idDivisaoTribunal: 0,
				nome: "",
				ativa: false,
				usuario: "",
				senha: "",
				tipoLinkDivisao: 0,
				legado: 0,
				classe: "",
				ordem: 0 ,
				limite: 0,
				contador: 0,
				idUsuarioAlteracao: 0,
				idUsuarioCadastro: 0,
				tipoCredencial: 0 ,
				observacao: "",
				statusTermoUso: false,
			},
			idFonte: 0,
			credencialFontes: [],
			perfisPortalCompleto: [],
			valueCredencialFonte: null,
			valueTipoCredencial: null,
			tpTipoCredencialData,
			termoAceite: false,
		};
	},
	mounted() {     
		this.fetch({ search: true });   
		this.textoTermo = this.$store.state.global.termoAceiteAdv;
	},
	methods: {
		habilitarFuncionalidade(funcionalidade) {
			let retorno = Helpers.funcionalidadeAutorizada({
				idTela: this.idTela,
				funcionalidade: funcionalidade
			});
			return retorno;
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},
		fetch(params = {}) {
			this.loading = true;
			this.getCredencialFontes();
			if (params.search) {
				params.idUsuario = this.$store.state.auth.idUser
				params.idPerfil = this.$store.state.auth.idPerfilPortal

				PortalCredencialWebApi.ListarCredenciaisInternas(params).then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Credencial", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Credencial", res.data.result);
						console.log(res.data.result)
					} else {
						this.data = res.data.result;
						this.pagination = { current: 1 };
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Credencial", "Erro ao tentar carregar usuários.");

				});
			} else {
				this.loading = false;
			}
		},
		handleClienteChange(value) {
			this.data = [];
			this.valueCliente = value;
			this.recuperarUsuario(value);
		},
		pesquisar() {
			this.data = [];
			this.loading = true;
			let filtro = { idUsuario: this.valueCredencial != null ? this.valueCredencial : 0};			
			PortalCredencialWebApi.controleContratos(filtro).then(res => {
				this.loading = false;				
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Controle Contrato", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Controle Contrato", res.data.result);
				} else {
					this.data = res.data.result;
					this.pagination = { current: 1 };
				}
			})
			.catch(res => {				
				this.loading = false;
				showNotificationError(this, "Controle Contrato", "Erro Controle Contrato.");
			});
		},
		getCredencialFontes(){
			this.credencialFontes = [];			
			PortalCredencialWebApi.getCredencialFontes()
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
					} else {
						this.credencialFontes.push.apply(this.credencialFontes, res.data.result.map(h => {
								return { idDivisaoTribunal: h.idDivisaoTribunal, nome: h.nome }
							}));						
						this.valueCredencialFonte = "";
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
				});
		},
		handleOkNewCred() {
			if (!this.validarCampos(this.credenciaisInternas)){
				return;
			}

			this.$root.loadingSpinner = true;
			this.idFonte = this.valueCredencialFonte;		
			this.credenciaisInternas.idUsuarioCadastro = this.$store.state.auth.idUser;
			this.credenciaisInternas.ativa = true;
			PortalCredencialWebApi.inserirCredencialInterna(this.credenciaisInternas, this.idFonte, this.$store.state.auth.idPerfilPortal )
				.then(res => {
					this.$refs.modalnewcred.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
					} else {
						showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
					}					
					this.fetch({ search: true, Text: this.textFilter });				
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar inserir credencial.");
				});
		},
		handleEditarCredencial(credenciaisInternas) {
			let fonteId =0
			this.credencialFontes.forEach(function(el, i){
				if(el.nome === credenciaisInternas.nome) {
					fonteId = el.idDivisaoTribunal;
				}
			});
			this.credenciaisInternas.idCredencial = credenciaisInternas.idCredencial;
			this.valueCredencialFonte = fonteId;
			this.credenciaisInternas.usuario = credenciaisInternas.usuario;
			this.credenciaisInternas.senha = credenciaisInternas.senha;
			this.credenciaisInternas.senha = credenciaisInternas.senha;
			this.credenciaisInternas.ordem = credenciaisInternas.ordem;
			this.credenciaisInternas.limite = credenciaisInternas.limite;
			this.credenciaisInternas.ativa = credenciaisInternas.ativa;
			this.valueTipoCredencial = credenciaisInternas.tipoCredencial;
			this.credenciaisInternas.observacao = credenciaisInternas.observacao;
			this.termoAceite = credenciaisInternas.statusTermoUso;
			this.$refs.modaleditcred.showModal();
		},
		onNewCredencial() {
			this.handleCancelNewCred();
			this.perfisPortal = this.$store.state.auth.idPerfilPortal != 1 ? this.perfisPortalCompleto.filter(y => {
				return y.idPerfilPortal != 1;
			}) : this.perfisPortalCompleto;

			this.$refs.modalnewcred.showModal();
		},
		handleCancelNewCred() {
			this.credenciaisInternas.idCredencial = 0;
			this.idFonte = 0;
			this.credenciaisInternas.usuario = '';
			this.credenciaisInternas.senha = '';
			this.credenciaisInternas.ativa = true;
			this.credenciaisInternas.ordem = 0;
			this.credenciaisInternas.limite = 0;
			this.termoAceite = false;
			this.$refs.modalnewcred.handleCancel();
		},
		validarCampos(credenciaisInternas){
			let camposValidos = true
			if (credenciaisInternas.usuario == ""){
				showNotificationError(this, "Cadastro de Credencial", "Usuário é um campo obrigatório!");
				camposValidos = false;	
			}else if (credenciaisInternas.senha == ""){
				showNotificationError(this, "Cadastro de Credencial", "Senha é um campo obrigatório!");
				camposValidos = false;
			}else if (credenciaisInternas.ordem == null){
				showNotificationError(this, "Cadastro de Credencial", "Ordem é um campo obrigatório!");
				camposValidos = false;
			}else if (credenciaisInternas.limite == null){
				showNotificationError(this, "Cadastro de Credencial", "Limite é um campo obrigatório!");
				camposValidos = false;
			}

			return camposValidos;
		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
		onShowModalImportPlanilha() {
			this.fileListUpload = [];
			this.termoAceite = false;
			this.$refs.modalCarregarPlanilha.showModal();
		},
		handleCancelModTermoAceite() {
			this.$refs.modalSalvarContrato.handleCancel();
			this.nomeFontesSelecionadas = '';
			this.termoAceite = false;
		},
		async onDownloadPlanModelo(){
			this.$root.loadingSpinner = true;
			PortalCredencialWebApi.downloadPlanilha()			
				.then(res => {
					this.$root.loadingSpinner = false;
					let data = res.data;					
					if (data !== null && typeof data !== "undefined") {
						let blob = new Blob([res.data], {
							type: "application/vnd.ms-excel"
						});
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "Planilha_Modelo.xlsx";	
						
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.handleCancelDownloadPlan();
					} else {
						showNotificationError(this, "Download Planilha", "Erro ao tentar fazer o download.");
					}
				})
				.catch(res => {					
					this.$root.loadingSpinner = false;
					showNotificationError(this, "Download Planilha", "Erro ao tentar fazer o download.");
				});
		},
		handleCancelDownloadPlan() {
			this.$refs.modalnewcred.handleCancel();
		},
		onImportarPlanilha(){
			this.$root.loadingSpinner = true;
			if (this.termoAceite == false){
				this.$root.loadingSpinner = false;
				showNotificationError(this, "Carregar Planilha", "É obrigatório aceitar os termos!");
				return;
			}

			if (this.fileListUpload.length <= 0){
				this.$root.loadingSpinner = false;
				showNotificationError(this, "Carregar Planilha", "É obrigatório informar um arquivo!");
				return;
			}
			
			PortalCredencialWebApi.carregarPlanilha(this.fileListUpload[0], this.$store.state.auth.idUser, this.$store.state.auth.idPerfilPortal, this.termoAceite )
				.then(res => {					
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
                        showNotificationSucess(this, "Carregar Planilha", res.data.errorMessage);
						this.handleCancelPlanImport();
						this.handleCancelDownloadPlan();
						this.fetch({ search: true });  
					} else {
						showNotificationError(this, "Carregar Planilha", res.data.errorMessage);
					}
				})
				.catch(res => {					
					this.$root.loadingSpinner = false;
					showNotificationError(this, "Carregar Planilha", "Erro ao tentar carregar a planilha.");
				});
		},
		handleCancelPlanImport() {
			this.$refs.modalCarregarPlanilha.handleCancel();
			this.myFilesImport = '';
		},
		onChangeCheck(e){
			this.termoAceite = e.target.checked;
			this.credenciaisInternas.statusTermoUso = this.termoAceite;
			
		},
		beforeUploadFile(file) {
			this.fileListUpload = [];
			this.fileListUpload = [...this.fileListUpload, file];
			return false;
		},
		handleRemoveFile(file) {
			const index = this.fileListUpload.indexOf(file);
			const newFileList = this.fileListUpload.slice();
			newFileList.splice(index, 1);
			this.fileListUpload = newFileList;
		},
		onSearch(text) {
			this.textFilter = text;
			this.fetch({ search: true, Text: this.textFilter });
		},
		handlerSwitchChange(value) {
			this.credenciaisInternas.ativa = value;
		},
		handleOkEditCli() {			
			if (!this.validarCampos(this.credenciaisInternas)){
				return;
			};

			if (this.credenciaisInternas.ativa == true) {
				this.credenciaisInternas.observacao = ''
			}
			this.chamarAPIEditarCredencial();
			
		},
		chamarAPIEditarCredencial() {
			this.$root.loadingSpinner = true;
			this.idFonte = this.valueCredencialFonte;
			PortalCredencialWebApi.atualizarCredencialInterna(this.credenciaisInternas, this.$store.state.auth.idUser, this.idFonte)
				.then(res => {
					this.handleCancelEditCredencialModal();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
						this.fetch({ search: true, Text: this.textFilter });					
					} else
						showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
				})
				.catch(res => {
					console.log(res)
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar editar Credencial.");
				});
		},
		handleCancelEditCredencialModal() {			
			this.credenciaisInternas.idUsuarioAlteracao = 0,
			this.credenciaisInternas.idUsuarioCadastro = 0,
			this.credenciaisInternas.idCredencial = 0;
			this.credenciaisInternas.nome = '';
			this.credenciaisInternas.usuario = '';
			this.credenciaisInternas.senha = '';
			this.credenciaisInternas.ativa = true;
			this.credenciaisInternas.classe = '';
			this.credenciaisInternas.ordem = 0;
			this.credenciaisInternas.limite = 0;
			this.credenciaisInternas.tipoCredencial = 0;
			this.credenciaisInternas.observacao = '';
			this.credenciaisInternas.statusTermoUso = false;
			this.dataModal = [];
			this.$refs.modaleditcred.handleCancel();
		},
		handleChangeCredencialFonte(value) {
			this.valueCredencialFonte = value == undefined ? "" : value;		
		},
		handleSelectTipoCredencialChange(value) {
			this.valueTipoCredencial = value;
			this.credenciaisInternas.tipoCredencial = this.valueTipoCredencial;
		},
	},    
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.content {
  height: 100%;
}

.ant-layout {
  height: 100%;
  background: "#fff";
}

.ant-layout-content {
  height: 100%;
  background: #fff;
}

.ant-layout-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
 
.cursor {
  cursor: pointer;
}

.cursor:hover {
  color: blue;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}

.config-form-button {
	width: 100px;
}

.tr-ant-select {
	margin: 10px 0px 10px 0px;
} 
</style>

<style>
.credencial-form-button {
	width: 100px;
}
</style>